/** ISO (yyyy-mm-dd) date `days` before today, so demo data stays current over time. */
export function daysAgo(days: number): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - days);
  return date.toISOString().slice(0, 10);
}
